module.exports = __webpack_public_path__ + "img/quick_nav6.b03cbf7a.png";